import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { UserSubscription, Subscription } from '../../models/Subscription';
import { SuscriptionType } from '../../enums/enum';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  protected basePath: any;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient) {
    this.basePath =
      environment.paymentBasePath + '/api/business-subscriptions';
  }

  /**
   * Récupère la liste des abonnements disponibles en fonction du code pays et du code devise spécifiés.
   *
   * @param country_code - Le code du pays pour filtrer les abonnements (par exemple, 'US', 'FR').
   * @param currency_code - Le code de la devise pour filtrer les abonnements (par exemple, 'USD', 'EUR').
   * @returns Un Observable émettant un tableau d'objets Subscription correspondant aux critères fournis.
   */
  public listSubscriptions(
    country_code: string,
    currency_code: string,
    type = SuscriptionType.BENEFIT,
  ): Observable<Subscription[]> {
    const queryParameters = new HttpParams({
      fromObject: {
        ...(country_code != null && { country_code: country_code }),
        ...(currency_code != null && { currency_code: currency_code }),
        ...(type != null && { type: type }),
      },
    });
    return this.http.get<Subscription[]>(`${this.basePath}`, {
      ...this.httpOptions,
      params: queryParameters,
    });
  }

  /**
   * Récupère l'abonnement de du groupe actuellement authentifié.
   *
   * Envoie une requête HTTP GET à l'API pour obtenir les informations d'abonnement
   * de l'utilisateur connecté. Retourne un Observable qui émet l'objet Subscription
   * correspondant.
   *
   * @returns {Observable<Subscription>} Un Observable émettant les détails de l'abonnement de l'utilisateur.
   */
  public getUserSubscription(): Observable<UserSubscription> {
    return this.http.get<UserSubscription>(
      `${this.basePath}/user`,
      this.httpOptions,
    );
  }

  /**
   * Retrieves the subscription details for the specified subscription UUID.
   *
   * @param subs_uuid - The unique identifier of the subscription to retrieve.
   * @returns An Observable that emits the Subscription object corresponding to the provided UUID.
   *
   * @remarks
   * This method sends a GET request to the backend to fetch the subscription details.
   * It is typically used to initiate the payment process for a subscription.
   */
  public paySubscription(
    subs_uuid: string,
    body: { business_uuid: string; domain: string },
  ): Observable<any> {
    return this.http.post<any>(
      `${this.basePath}/${subs_uuid}`,
      body,
      this.httpOptions,
    );
  }
}
